import { GetOperatorMeResponse } from '@/modules/operator/type'
import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getOperatorMe } from '../../services'
import { OperatorQueryKey } from '@/modules/operator/keys'

export default function useQueryGetOperatorMe(
	props?: UseBaseQueryOptions<GetOperatorMeResponse>,
) {
	return useQuery({
		queryKey: [OperatorQueryKey.GetMeOperator],
		queryFn: () => getOperatorMe(),
		...props,
	})
}
